import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ListLoadingMotionProps {
  listCount?: number;
}

export const ListLoadingMotion = ({ listCount = 20 }: ListLoadingMotionProps) => {
  const listEls = new Array(listCount).fill(null).map((_, index) => <LoadingListItem key={index} />);

  return <ul className={cx('listWrap')}>{listEls}</ul>;
};

export const LoadingListItem = () => {
  return (
    <li className={cx('itemArea')}>
      <div className={cx('imgArea')} />
      <div className={cx('contentsArea')}>
        <div className={cx('nameWrap')} />
      </div>
    </li>
  );
};
